import { render, staticRenderFns } from "./kv.vue?vue&type=template&id=db2b8e1a&scoped=true"
import script from "./kv.vue?vue&type=script&lang=js"
export * from "./kv.vue?vue&type=script&lang=js"
import style0 from "./kv.vue?vue&type=style&index=0&id=db2b8e1a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db2b8e1a",
  null
  
)

export default component.exports